<script setup>
  const props = defineProps({
    job: { required: true, type: Object },
    color: { required: true, type: String }
  })

  const { path } = useRoute()
</script>

<template>
  <section class="relative flex-1 space-y-6 px-4 py-8 text-sm sm:px-8 sm:text-base lg:ml-80 lg:px-12 lg:pb-24 xl:px-16 xl:py-12">
    <div class="flex flex-col space-y-3" v-if="job.answer2">
      <h3 class="text-lg font-bold sm:text-xl">Présentation</h3>
      <Markdown class="text-[#1f1f1f] marker:prose-ul:!text-[#1f1f1f]" :content="job.answer2" />
      <NuxtLink class="job-link underline decoration-2 underline-offset-2" :to="path.split('/jobs')[0]">Découvrez notre institution </NuxtLink>
    </div>
    <div class="space-y-3" v-if="job.answer1">
      <h3 class="text-lg font-bold sm:text-xl">Description des missions</h3>
      <Markdown class="text-[#1f1f1f] marker:prose-ul:!text-[#1f1f1f]" :content="job.answer1" />
    </div>
    <div class="space-y-3" v-if="job.answer3">
      <h3 class="text-lg font-bold sm:text-xl">Profil recherché</h3>
      <Markdown class="text-[#1f1f1f] marker:prose-ul:!text-[#1f1f1f]" :content="job.answer3" />
    </div>
    <div class="space-y-3" v-if="job.advantages">
      <h3 class="text-lg font-bold sm:text-xl">Avantages</h3>
      <Markdown class="text-[#1f1f1f] marker:prose-ul:!text-[#1f1f1f]" :content="job.advantages" />
    </div>
    <div class="space-y-3" v-if="job.jobSheet">
      <NuxtLink class="job-link underline decoration-2 underline-offset-2" target="_blank" :to="useStrapiMedia(job.jobSheet.url)"
        >Téléchargez la fiche de poste</NuxtLink
      >
    </div>
  </section>
</template>
